import { Injectable } from '@angular/core';

@Injectable()
export class Framework {
  name: string;
  framework: any;
  widgets?: { [key: string]: any } = {};
  stylesheets?: string[] = [];
  scripts?: string[] = [];
};



// WEBPACK FOOTER //
// /Users/David/Sites/angular2-json-schema-form/src/lib/src/framework-library/framework.ts